// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hhUf9","content":"styles_content__16-9Y","row":"styles_row__2PFaS","footer":"styles_footer__3_2x5","phraseLength":"styles_phraseLength__1HSZ7"};